import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { getSDM17SPGs } from '../../data/SDM17SPG/actions';

class SDM17SPG extends PureComponent {
    static propTypes = {
        initialized: PropTypes.bool.isRequired,
        getSDM17SPGs: PropTypes.func.isRequired,
        SDM17SPGs: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshSDM17SPGs();
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `SDM17SPG/detail/${rowData.id}` });
    };

    /* ACTIONS */
    refreshSDM17SPGs = () => {
        const { getSDM17SPGs } = this.props;
        this.setState({ loading: true });
        return getSDM17SPGs()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    /* RENDER */
    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRight = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`general.products.SDM17SPG.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshSDM17SPGs
                }
            ]
        };
        if (profile.get('admin') || userRight.includes('SDM17SPGDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate(`general.showDetail`),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderData = memoizeOne(SDM17SPGs => {
        let result = [];
        SDM17SPGs.map(SDM17SPG => {
            result.push({
                id: SDM17SPG.get('macAddress'),
                macAddress: SDM17SPG.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                addressIp: SDM17SPG.get('addressIp'),
                email: SDM17SPG.get('userEmail'),
                label: SDM17SPG.get('label'),
                state: SDM17SPG.getIn(['state'], false) ? Translator.translate(`general.${SDM17SPG.get('state')}`) : null,
                firmwareVersion: SDM17SPG.get('firmwareVersion'),
                usersList: SDM17SPG.get('usersList'),
                userMasterId: SDM17SPG.get('userMasterId')
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('SDM17SPGDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.addressIp'),
                name: 'addressIp'
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            }
        ];
    });
    render() {
        const { loading } = this.state;
        const { profile, SDM17SPGs, history } = this.props;

        return (
            <FHETable
                idTable="SDM17SPGList"
                columns={this.renderColumns(profile)}
                data={this.renderData(SDM17SPGs)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`general.products.SDM17SPG.table.title`)}
                emptyDataSourceMessage={Translator.translate(`general.products.SDM17SPG.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const users = state.environments[history.environment].data.Users.get('list');
    let SDM17SPGs = state.environments[history.environment].data.SDM17SPG.get('list');
    SDM17SPGs = SDM17SPGs.map(SDM17SPG => {
        const masterId = SDM17SPG.getIn(['userMasterId'], '');
        return SDM17SPG.setIn(['userEmail'], users.getIn([masterId && masterId.toString(), 'email'], ''));
    });

    return {
        profile: state.data.user,
        SDM17SPGs,
        initialized: state.environments[history.environment].data.SDM17SPG.get('initialized')
    };
}
const styles = theme => ({
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getSDM17SPGs }, dispatch)
    )(withStyles(styles, { withTheme: true })(SDM17SPG))
);



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/SDM17SPG/index.js